import * as types from "./mutation-type";

export default {
    [types.SET_OBSERVACAO](state, payload) {
        state.observacao = payload
      },
}
